import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { Contact, Menu } from './site.model';

@Injectable({
  providedIn: 'root'
})
export class SiteService {

    php = '../php/';
    errorData: {};

    httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
    };

    constructor(
        private http: HttpClient
    ) { }

    navigateMenu = [
        {
            label: 'Home',
            path: 'main',
            section: 'home'
        } as Menu,
        {
            label: 'About',
            path: 'about'
        } as Menu,
        {
            label: 'Services',
            path: 'services'
        } as Menu,
        {
            label: 'Locations',
            path: 'main',
            section: 'main-contacts'
        } as Menu,
    ];

    getReviews(): Observable<any> {
        const accountId = '';
        const locationId = '';
        return this.http.get(`https://mybusiness.googleapis.com/v4/accounts/${accountId}/locations/${locationId}/reviews`);
    }

    getPage(slug: string) {
        return this.http.get<any>(this.php + 'formmailer.php')
            .pipe(
                catchError(this.handleError)
            );
    }

    contactForm(formdata: Contact) {
        return this.http.post<Contact>(this.php + 'formmailer.php', formdata, this.httpOptions).pipe(
            catchError(this.handleError)
        );
    }

    PostMessage(input: any) {
        return this.http.post(this.php + 'formmailer.php', input, { responseType: 'text' })
            .pipe(
                map(
                    (response) => {
                        if (response) {
                            return response;
                        }
                    },
                    (error: any) => {
                        return error;
                    }
                )
            );
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {

            // A client-side or network error occurred. Handle it accordingly.

            console.error('An error occurred:', error.error.message);
        } else {

            // The backend returned an unsuccessful response code.

            // The response body may contain clues as to what went wrong.

            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }

        // return an observable with a user-facing error message

        this.errorData = {
            errorTitle: 'Oops! Request for document failed',
            errorDesc: 'Something bad happened. Please try again later.'
        };
        return throwError(this.errorData);
    }
}
